export function PayrollDeductionsPage () {
  return (
    <div>
      <h1 className='heading-lg mb-6'>Payroll Deductions</h1>
    </div>
  )
}
